import React from "react";
import { useDispatch } from "react-redux";
import { setShowRuler } from "../../redux/actions/LiveImageAction";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { setShowCrossHair } from "./../../redux/actions/LiveImageAction";
import { getShowCrossHair, getShowRuler } from "./../../redux/reducers/LiveImageReducer";
import SwitchButton from "./../Buttons/SwitchButton";
import "./LiveImagePreferences.css";
import ImagerApi from "../../api/ImagerApi";
import { getModuleStateById } from "../../redux/reducers/ModuleStateReducer";

export type Props = {
  imagerIdentifier: string;
};

export default function LiveImagePreferences({ imagerIdentifier }: Props) {
  const dispatch = useDispatch();
  const ruler = useTypedSelector((state) => getShowRuler(state));
  const crosshair = useTypedSelector((state) => getShowCrossHair(state));
  const imagerState = useTypedSelector((state) => getModuleStateById(state)[imagerIdentifier].imager);
  if (imagerState == null) {
    throw new Error("Imager state is null");
  }

  const onToggleScaleBar = () => {
    dispatch(setShowRuler(!ruler));
  };
  const onToggleCrosshair = () => {
    dispatch(setShowCrossHair(!crosshair));
  };
  const onToggleBestFit = (isOn: boolean) => {
    ImagerApi.setBestFit(imagerIdentifier, isOn);
  };

  return (
    <div className="live-image-pref">
      <div className="live-image-pref-row">
        <span>Enable Scale Bar:</span>
        <SwitchButton isOn={ruler} onToggle={() => onToggleScaleBar()} withLetter={false} />
      </div>
      <div className="live-image-pref-row">
        <span>Enable Crosshair Guide:</span>
        <SwitchButton isOn={crosshair} onToggle={() => onToggleCrosshair()} withLetter={false} />
      </div>
      <div className="live-image-pref-row">
        <span>Best Fit: </span>
        <SwitchButton isOn={imagerState.bestFit} onToggle={(isOn) => onToggleBestFit(isOn)} withLetter={false} />
      </div>
    </div>
  );
}
